import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import RecentPostList from '../Components/RecentPostList';
import RelatedPostList from '../Components/RelatedPost';
import TagItems from '../Components/TagItems';
import PrevNextPost from '../Components/PrevNextPost';
import AuthorBio from '../Components/AuthorBio';
import CategoryWidget from '../Components/CategoryWidget';
import TagWidget from '../Components/TagWidget';
import CommentList from '../Components/CommentList';
import CommentBox from '../Components/CommentBox';
//import '../css/blog.css';
import { GetPostBySlug } from '../services/apiservice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faClock, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';

const BlogDetail = () => {
  const [blogPost, setBlogPost] = useState([]);
  const { paramlink } = useParams(); // 👈 get the slug from URL

  const fillBlogDetail = async () => {
    try {
      const postdetail = await GetPostBySlug(paramlink);
      const jsonPostDetail = JSON.parse(postdetail);
      setBlogPost(jsonPostDetail);
    } catch (error) {
      console.error('Error fetching the data:', error);
    }
  }

  useEffect(() => {
    fillBlogDetail();
  }, [paramlink]);

  return (
    <div>
      <Header />

      <section class="blog-area blog-section blog-details-area ptb-20">
        <div class="container-block-fluid">
          <div class="row">
            <div class="full-col col-lg-8 col-12">
              <div class="blog-details-left-area">
                <div class="blog-details-single-post" data-aos="fade-up"
                  data-aos-duration="1400">
                  <div class="blog-details-img">
                    <img src={blogPost.mediapath} alt="Image" />
                  </div>

                  <ul>
                    <li><i class="bx bx-time"></i> {blogPost.posteddate}</li>
                    <li>
                      <a href="#">
                        <i class="bx bx-street-view"></i>
                        {blogPost.views}
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i class="bx bx-comment"></i>
                        {blogPost.readtime} mins read
                      </a>
                    </li>
                  </ul>
                  <div className="tag-items pb-20">
                    <TagItems postSlug={paramlink} />
                  </div>
                  <h3>{blogPost.title}</h3>
                  <div className='dropcap-paragraph' dangerouslySetInnerHTML={{ __html: blogPost.description }} />
                </div>

                <div class="blog-details-sheare" data-aos="fade-up"
                  data-aos-duration="2000">
                  <div class="row align-items-center">
                    <div class="col-lg-6 col-sm-6">
                      <div class="blog-sheare-tag">
                        <ul>
                          <li>Share</li>
                        </ul>
                      </div>
                    </div>

                    <div class="col-lg-6 col-sm-6">
                      <ul class="social-icon">
                        <li>
                          <a href="#">
                            <i class="bx bxl-facebook"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i class="bx bxl-twitter"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i class="bx bxl-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i class="bx bxl-linkedin"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i class="bx bxl-youtube"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="prev-next" data-aos="fade-up"
                  data-aos-duration="2200">
                  <PrevNextPost postSlug={paramlink} />
                </div>

                <div class="profile" data-aos="fade-up"
                  data-aos-duration="2400">
                  <AuthorBio postData={blogPost} />
                </div>
                
                {/* <CommentList /> */}
                <RelatedPostList postSlug={paramlink} />
                
                {/* <CommentBox /> */}

              </div>
            </div>
            <div class="full-col col-lg-4 col-12">
              <div class="blog-details-right-area blog-right-sidebar">
                {/* <div class="blog-widget search-widget" data-aos="fade-up"
                  data-aos-duration="800">
                  <form class="search-form">
                    <input type="search" class="form-control" placeholder="Search..." />
                    <button type="submit">
                      <i class="bx bx-search"></i>
                    </button>
                  </form>
                </div> */}

                <div class="blog-widget recent-post-widget" data-aos="fade-up"
                  data-aos-duration="1200">
                  <RecentPostList />
                </div>

                <div class="blog-widget categories-widget" data-aos="fade-up"
                  data-aos-duration="2400">
                  <CategoryWidget />
                </div>

                <div class="blog-widget tags-widget" data-aos="fade-up"
                  data-aos-duration="2800">
                  <TagWidget />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default BlogDetail;